import { Divider, Stack, useTheme } from '@mui/material'

import CampaignEditTitle from '~/features/campaigns/components/ofuManageCampaign/campaignEditTitle'
import OfuManageBackButton from '~/features/campaigns/components/ofuManageCampaign/ofuManageBackButton'
import OfuManageCampaignActions from '~/features/campaigns/components/ofuManageCampaign/ofuManageCampaignActions'
import OfuManageCampaignStatus from '~/features/campaigns/components/ofuManageCampaign/ofuManageCampaignStatus'
import OfuManageTitle from '~/features/campaigns/components/ofuManageCampaign/ofuManageTitle'
import { ECapability } from '~/features/user/models'
import useCapabilities from '~/hooks/useCapabilities'
import rem from '~/utils/ui'

export default function OfuManageTopBar() {
  const theme = useTheme()
  const { canEdit } = useCapabilities()
  const canEditCampaigns = canEdit(ECapability.campaigns)

  return (
    <Stack
      sx={{
        width: '100%',
        px: 4,
        py: 1.5,
        backgroundColor: theme.palette.common.white,
        borderBottom: `${rem(1)} solid ${theme.palette.divider}`,
        overflow: 'hidden',
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{ minWidth: 0, flex: 1 }}
        gap={2}
      >
        <OfuManageBackButton />
        <Divider
          orientation="vertical"
          sx={{
            height: rem(32),
            mx: rem(16),
            borderColor: theme.palette.divider,
            my: 'auto',
          }}
        />

        <Stack
          direction="row"
          alignItems="center"
          gap={0.5}
          flex={1}
          overflow="hidden"
        >
          <OfuManageTitle />
          {canEditCampaigns && <CampaignEditTitle />}
        </Stack>
      </Stack>

      <Stack direction="row" alignItems="center">
        <OfuManageCampaignStatus />
        {canEditCampaigns && (
          <>
            <Divider
              orientation="vertical"
              sx={{
                height: rem(32),
                mx: rem(16),
                borderColor: theme.palette.divider,
              }}
            />
            <OfuManageCampaignActions />
          </>
        )}
      </Stack>
    </Stack>
  )
}
